"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HappyFox", {
  enumerable: true,
  get: function get() {
    return _HappyFox["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _HelpCenter["default"];
  }
});
var _HappyFox = _interopRequireDefault(require("./components/HappyFox"));
var _HelpCenter = _interopRequireDefault(require("./components/HelpCenter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }